var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.state !== "unavailable"
    ? _c("div", { staticClass: "google-signin mt-2" }, [
        _vm._m(0),
        _c("div", {
          ref: "button",
          staticClass: "google-button-slot",
          class: { "is-busy": _vm.busy },
        }),
        _vm.state === "loading"
          ? _c(
              "small",
              { staticClass: "text-muted d-block text-center mt-1" },
              [_vm._v("Carregando…")]
            )
          : _vm._e(),
        _vm.busy
          ? _c(
              "small",
              { staticClass: "text-muted d-block text-center mt-1" },
              [_vm._v("Entrando com o Google…")]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "google-divider" }, [
      _c("span", [_vm._v("ou")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }